import React, { useMemo } from "react";
import { useGetHtmlApiQuery } from "../../redux/services/apiHome";
import Loader from "../../components/Loader";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import {
  convertStringToArray,
  getDateUpdate,
  sanitizeString,
} from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import usePagination from "../../hooks/usePagination";
import Pagination from "../../components/Pagination/Pagination";
import { useLocation, useNavigate } from "react-router-dom";
import { imageUrl } from "../../constants/constants";
import useSeo from "../../hooks/useSeo";

const ArchivedNews = () => {
  const navigate = useNavigate();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  const { data: archivedNewsHtml = {}, isLoading: archivedNewsHtmlIsLoading } =
    useGetHtmlApiQuery({ url: 663, lang: languageType });

  const lastUpdatedOn = useMemo(() => {
    return getDateUpdate(archivedNewsHtml?.changed?.[0].value);
  }, [archivedNewsHtml]);

  const { data: archiveData = [], isLoading: archiveIsLoading } =
    useGetProtectedApiDataQuery({
      url: "archive_latest_news",
      lang: languageType,
    });

  const transformedArchivedData = useMemo(() => {
    return archiveData.map((item) => ({
      ...item,
      field_upload_image: convertStringToArray(item.field_upload_image),
    }));
  }, [archiveData]);

  const { currentItems, currentPage, totalPages, handlePageChange } =
    usePagination(transformedArchivedData, 10);

  const handlePhotoClick = (nid) => {
    navigate(`/news-archive/${nid}`);
  };

  if (archiveIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        titleLink={"/archived-news"}
        levelTwo={false}
        levelThree={false}
        bannerImage={innerBannerImage}
        title={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <section className="ourCompany latest-news">
          <div className="container">
            <div className="container">
              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
              <div className="row">
                <div className="container">
                  <div className="title-sec">{/* <h4>{pageTitle}</h4> */}</div>
                  {/* <div dangerouslySetInnerHTML={{ __html: pageBody }} /> */}
                </div>
              </div>
              <div className="row mb-5">
                {currentItems.map((item, index) => {
                  const title = sanitizeString(item.title);
                  const desc = sanitizeString(item.body);
                  return (
                    <div
                      className="col-12 col-sm-12 col-md-6 col-lg-6"
                      key={index}
                    >
                      <div
                        className="card-sec wow zoomIn"
                        onClick={() => handlePhotoClick(item.nid)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="img-sec">
                          <img
                            alt={title}
                            src={
                              item?.field_upload_image?.[0]?.file_path
                                ? imageUrl +
                                  item.field_upload_image[0].file_path
                                : "images/dummy.png"
                            }
                          />
                        </div>
                        <div className="desc-sec">
                          {item?.field_ordering_date && (
                            <span className="date">
                              {item?.field_ordering_date}
                            </span>
                          )}

                          <a
                            href="#"
                            role="button"
                            tabIndex={0}
                            onClick={(e) => e.preventDefault()}
                          >
                            {title}
                          </a>
                          <p className="line-clamp line-clamp-5">{desc}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </section>
      </div>
    </>
  );
};

export default ArchivedNews;
